import { VehicleColours } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehiclecolours';
import { VehicleOption } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicleoption';
import { VehicleOptionItem } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicleoptionitem';
import { AvailableOption } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/availableoption';
import { VehicleColourOption } from 'interface';

export const gelSelectedColourOptions = (
  colourOptions: AvailableOption[]
): number[] => {
  if (colourOptions && colourOptions.length > 0) {
    return colourOptions
      .reduce(function (result: AvailableOption[], arr) {
        return result.concat(arr);
      }, [])
      .filter((subItem) => subItem.checked)
      .map((x) => x.id);
  } else {
    return [];
  }
};

export const gelAllSelectedColourOptions = (
  vehicleColours: VehicleColours
): number[] => {
  if (vehicleColours) {
    const selectedHoods = vehicleColours.hood
      .reduce(function (result: AvailableOption[], arr) {
        return result.concat(arr);
      }, [])
      .filter((subItem) => subItem.checked)
      .map((x) => x.id);
    const selectedTrim = vehicleColours.trim
      .reduce(function (result: AvailableOption[], arr) {
        return result.concat(arr);
      }, [])
      .filter((subItem) => subItem.checked)
      .map((x) => x.id);
    const selectedPaint = vehicleColours.paint
      .reduce(function (result: AvailableOption[], arr) {
        return result.concat(arr);
      }, [])
      .filter((subItem) => subItem.checked)
      .map((x) => x.id);

    return [...selectedHoods, ...selectedPaint, ...selectedTrim];
  } else {
    return [];
  }
};

export const gelSelectedCustomOptions = (
  customOptions: VehicleOption[]
): number[] => {
  if (customOptions && customOptions.length > 0) {
    return customOptions
      .map((child) => child.items)
      .reduce(function (result: VehicleOptionItem[], arr) {
        return result.concat(arr);
      }, [])
      .filter((subItem) => subItem.checked)
      .map((x) => x.id);
  } else {
    return [];
  }
};

export const getMatchedPrices = (
  colourPrices: AvailableOption[],
  colourList: VehicleColourOption[]
) => {
  return colourPrices.map((price, index) => {
    const colour = colourList?.filter(
      (priceItem) => priceItem.description === price.title
    );
    return {
      ...colour[0],
      ...price,
      index,
    };
  });
};
